<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      line-form
      title="选择核销类型"
      :data="data"
      :form-rules="rules"
      @closed="onClosed"
    >
      <template slot="form">
        <el-form-item label="核销类型">
          <el-select v-model="data.BusinessType">
            <el-option label="收款核销" :value="0"></el-option>
            <el-option label="付款核销" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="往来单位" prop="TradeUnitId">
          <select-input
            placeholder="请选择单位"
            :label="data.TradeUnitName"
            v-model="data.TradeUnitId"
            @click="openTradeunit"
          />
        </el-form-item>
        <el-form-item label="截止日期" prop="DocDateEnd">
          <range-picker
            style="border: none;margin-left: 9px;min-width:180px;"
            :date="[data.DocDateStart, data.DocDateEnd]"
            @change="x=>{data.DocDateStart=x.Start;data.DocDateEnd=x.End;}"
          />
        </el-form-item>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="save">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    
      <tradeunit-dialog ref="tradeunitDialog" in-dialog selectable @select="setTradeunit" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    tradeunitDialog,
  },
  data() {
    return {
      data: {
        BusinessType: 0, //收款核销/付款核销
        TradeUnitId: null,
        TradeUnitName: "",
        DocDateStart: this.$commonJs.getToday(),
        DocDateEnd: this.$commonJs.getToday(),
      },
      isSave: false,
      saveDto: null,
      rules: {
        TradeUnitId: [{ required: true, message: "请选择往来单位" }],
        DocDateEnd: [{ required: true, message: "截止日期不能为空" }],
      },
    };
  },
  methods: {
    openTradeunit() {
      if(this.data.BusinessType==0){
        this.$refs.tradeunitDialog.open().then((that) => {
        that.getData({TradeUnitTypes:[0,2],Status:1});
      });
      }else{
        this.$refs.tradeunitDialog.open().then((that) => {
        that.getData({TradeUnitTypes:[1,2,3],Status:1});
      });
      }
     
    },
    setTradeunit(data) {
      this.data.TradeUnitId = data.TradeUnitId;
      this.data.TradeUnitName = data.FullName;
    },
    save() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;

        this.isSave = true;
        this.saveDto = { ...this.data };
        this.close(true);
      });
    },
    onClosed() {
      if (this.isSave) this.$emit("confirm", { ...this.saveDto });
      this.isSave = false;
    },
  },
};
</script>